<template>
  <div class="drawer-wrapper">
    <el-drawer :title="title" :wrapperClosable="true" :visible.sync="vipFlag" size="50%" :before-close="handleClose">
      <div class="demo-drawer__content">
        <el-form :model="addFrom" size="medium"  class="mt35" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="角色组" :label-width="formLabelWidth">
                <el-select v-model="nameRole" placeholder="请选择角色组" clearable style="width: 90%;" :disabled="true">
                  <el-option label="正常" value="1"></el-option>
                  <el-option label="隐藏" value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="用户名" prop="username" :label-width="formLabelWidth">
                <el-input v-model="addFrom.username" placeholder="请输入用户名称" clearable  style="width: 90%;"
                          :disabled="EditFlag"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="昵称" prop="nickname" :label-width="formLabelWidth">
                <el-input v-model="addFrom.nickname" placeholder="请输入昵称" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="密码" prop="password" :label-width="formLabelWidth">
                <el-input v-model="addFrom.password" placeholder="请输入密码" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="邮箱" :label-width="formLabelWidth">
                <el-input v-model="addFrom.email" placeholder="请输入邮箱" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="手机号" :label-width="formLabelWidth">
                <el-input v-model="addFrom.mobile" placeholder="请输入手机号" clearable style="width: 90%;"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="付费类型" prop="pay_type" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.pay_type" @change="payTypeChange" :disabled="flagTab">
                  <el-radio :label="0">IAP</el-radio>
                 
                </el-radio-group>
              </el-form-item>
            </el-col>
            <!-- <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="个人中心充值入口" prop="" :label-width="formLabelWidth">
                <el-switch
                    v-model="addFrom.pay_switch"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col> -->
           
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="微信小程序" prop="wx_appid" :label-width="formLabelWidth">
                <el-select v-if="isUpdateWx" v-model="addFrom.wx_appid" placeholder="请选择小程序名称" clearable style="width: 90%;">
                  <el-option v-for="dict in WeChatList" :key="dict.dictValue" :label="dict.name" :value="dict.uuid"/>
                </el-select>
                <el-input v-else v-model="addFrom.wx_appname" clearable style="width: 90%;"
                          :disabled="isInputDisabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">隐藏</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
           
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="投放类型" prop="launch_type" :label-width="formLabelWidth">
                <el-radio-group v-model="addFrom.launch_type" @change="AddChange" :disabled="flagTab">
                  <el-radio :label="0">内部自投</el-radio>
                  <el-radio :label="1">渠道分销</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="设置免费剧集和单剧价格开关" prop="" :label-width="formLabelWidth">
                <el-switch
                v-model="addFrom.chapter_switch"
                active-color="#13ce66"
                inactive-color="#ff4949"
                :active-value="1"
                :inactive-value="0"
            >
            </el-switch>
              </el-form-item>
            </el-col>

          </el-row>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="合作公司简称" prop="company_abbr" :label-width="formLabelWidth">
              <el-input v-model="addFrom.company_abbr" placeholder="请输入公司简称" clearable style="width: 90%;"
                        :disabled="isInputDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="合作公司全称" prop="company_name" :label-width="formLabelWidth">
              <el-input v-model="addFrom.company_name" placeholder="请输入合作公司全称" clearable style="width: 90%;"
                        :disabled="isInputDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="抽成比例" prop="benefit" :label-width="formLabelWidth">
              <el-input v-model="addFrom.benefit" placeholder="请输入抽成比例" clearable style="width: 90%;"
                        :disabled="isInputDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="收款方式" prop="pay_method" :label-width="formLabelWidth">
              <el-radio-group v-model="addFrom.pay_method" @change="PublicPrivate" :disabled="flagTab">
                <el-radio label="1">对公</el-radio>
                <el-radio label="2">对私</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="收款人" prop="card_holder" :label-width="formLabelWidth">
              <el-input v-model="addFrom.card_holder" placeholder="请输入收款人" clearable style="width: 90%;"
                        :disabled="flagTab"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="收款账号" prop="card_num" :label-width="formLabelWidth">
              <el-input v-model="addFrom.card_num" placeholder="请输入收款账号" clearable style="width: 90%;"
                        :disabled="flagTab"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
            <el-form-item label="收款银行" prop="card_bank" :label-width="formLabelWidth">
              <el-input v-model.number="addFrom.card_bank" placeholder="请输入收款银行" clearable style="width: 90%;"
                        :disabled="flagTab"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </div>

      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {VIPmanagementAPI} from '@/api/account/VIPmanagement';
import {processErrors} from "@/utils/errorHandler";

export default {
  props: ['vipFlag', "editID"],
  components: {},
  data() {
    return {
      title: "新增",
      formLabelWidth: "140px",
      addFrom: {
        username: "",
        nickname: "",
        password: "",
        email: "",
        mobile: "",
        status: 1,
        id: "",
        group: "3",
        launch_type: 0,
        company_abbr: "秋分书城",
        chapter_switch:0,
        pay_switch: 1,
        zj_appname: "",
        wx_appname: "",
        company_name: "秋分书城",
        benefit: "0",
        pay_method: "1",
        card_holder: "内部",
        card_num: "内部",
        card_bank: "内部",
        zj_appid: "",
        wx_appid: "",
        pay_type: 0,
      },
       rules: {
        username: [
          {required: true, message: '请输入用户名', trigger: 'blur'},
          {min: 6, max: 20, pattern: /^[a-zA-Z0-9_-]{6,20}$/, message: '用户名6-20位包含数字和字母', trigger: 'blur'},
        ],
        nickname: [
          {required: true, message: '请输入昵称', trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入密码', trigger: 'blur'},
          {min: 6, pattern: /^(?=.*[a-zA-Z])(?=.*\d).{6,}$/, message: '密码至少6位包含数字和字母', trigger: 'blur'},
        ],
        zj_appid: [{required: true, message: '请选择小程序', trigger: 'blur'}],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        launch_type: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        company_abbr: [
          {required: true, message: '请输入合作公司简称', trigger: 'blur'},
        ],
         pay_type: [
           {required: true, message: '请选择付费类型', trigger: 'change'}
         ],

        company_name: [
          {required: true, message: '请输入合作公司全称', trigger: 'blur'},
        ],
        benefit: [
          {required: true, message: '请输入抽成比例', trigger: 'blur'},
        ],
        pay_method: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        card_holder: [
          {required: true, message: '请输入收款人', trigger: 'blur'},
        ],
        card_num: [
          {required: true, message: '请输入收款账号', trigger: 'blur'},
        ],
        card_bank: [
          {required: true, message: '请输入收款银行', trigger: 'blur'},
        ],
        wx_appid: [
          {required: true, message: '请选择微信小程序', trigger: 'blur'},
        ],
      },
      appidList: [],
      EditFlag: false,
      isInputDisabled: true,
      radioFlag: true,
      TiktokList: [],
      WeChatList: [],
      page: {
        pageNo: 1,
        pageSize: 999,
        type: "1"
      },
      nameRole: "渠道",
      flagTab: false,
      isUpdateDy: true,
      isUpdateWx: true,
    };
  },
  created() {
    this.getroleList()
    this.GetSlect()
    this.GetWXSlect()
  },
  methods: {
    handleClose(done) {
      this.$emit('NonevipFlag');
      this.$refs['ruleForm'].resetFields();
    },
    payTypeChange() {
      if (this.addFrom.pay_type == 0) {
        
        
        this.GetSlect();
        this.GetWXSlect();
        this.addFrom.zj_appid=""
        this.addFrom.wx_appid=""

      }else{
        this.GetSlect(1);
        this.GetWXSlect(1);
        this.addFrom.zj_appid=""
        this.addFrom.wx_appid=""
      }
    },
    AddChange() {
      if (this.addFrom.launch_type == 0) {
        this.addFrom.company_abbr = "秋分书城",
            this.addFrom.company_name = "秋分书城",
            this.addFrom.benefit = "0"
        // this.addFrom.pay_method = "1",
            this.addFrom.card_holder = "内部",
            this.addFrom.card_num = "内部",
            this.addFrom.card_bank = "内部"
        this.isInputDisabled = true


      } else {
        this.addFrom.company_abbr = "";
        this.addFrom.company_name = "";
        this.addFrom.benefit = "";
        // this.addFrom.pay_method = "2",
            this.addFrom.card_holder = "",
            this.addFrom.card_num = "",
            this.addFrom.card_bank = ""
        this.isInputDisabled = false

      }
    },
    PublicPrivate() {
      // if (this.addFrom.pay_method == "1") {
      //   this.addFrom.card_holder = "内部",
      //       this.addFrom.card_num = "内部",
      //       this.addFrom.card_bank = "内部"
      // } else {
      //   this.addFrom.card_holder = "",
      //       this.addFrom.card_num = "",
      //       this.addFrom.card_bank = ""
      //   this.radioFlag = false
      // }
    },
    AddNone() {
      this.addFrom = {
        username: "",
        nickname: "",
        password: "",
        email: "",
        mobile: "",
        status: "",
        id: "",
        group: "3",
        launch_type: 0,
        chapter_switch:0,
        pay_switch: 1,
        company_abbr: "秋分书城",
        zj_appname: "",
        wx_appname: "",
        company_name: "秋分书城",
        benefit: "0",
        pay_method: "1",
        card_holder: "内部",
        card_num: "内部",
        card_bank: "内部",
        zj_appid: "",
        wx_appid: "",
      },
          this.title = ""
      this.$refs['ruleForm'].resetFields();
      this.$emit('NonevipFlag');
    },
    getroleList() {
      let api = VIPmanagementAPI()
      api.roleList(this.page).then(res => {
        if (res.code == 0) {
          this.appidList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },
    GetSlect(iaa=0) {
      let api = VIPmanagementAPI()
      let params = {
        status: 1,
        platform_type: 1,
        iaa
      }
      api.applicationList(params).then(res => {
        if (res.code == 0) {
          this.TiktokList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },

    GetWXSlect(iaa=0) {
      let api = VIPmanagementAPI()
      let params = {
        status: 1,
        platform_type: 2,
        iaa
      }
      api.applicationList(params).then(res => {
        if (res.code == 0) {
          this.WeChatList = res.data.data
        } else {
          processErrors(res);
        }
      })
    },

    addPush() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          let api = VIPmanagementAPI()
          let obj = {
            username: this.addFrom.username,
            nickname: this.addFrom.nickname,
            password: this.addFrom.password,
            email: this.addFrom.email,
            mobile: this.addFrom.mobile,
            status: this.addFrom.status,
            id: this.addFrom.id,
            group: this.addFrom.group,

            config: {
              launch_type: this.addFrom.launch_type,
              chapter_switch: this.addFrom.chapter_switch,
              pay_switch: this.addFrom.pay_switch,
              company_abbr: this.addFrom.company_abbr,
              company_name: this.addFrom.company_name,
              zj_appid: this.addFrom.zj_appid,
              wx_appid: this.addFrom.wx_appid,
              zj_appname: this.addFrom.zj_appname,
              wx_appname: this.addFrom.wx_appname,
              pay_type: this.addFrom.pay_type,
            },
            extend: {
              benefit: this.addFrom.benefit,
              pay_method: this.addFrom.pay_method,
              card_holder: this.addFrom.card_holder,
              card_num: this.addFrom.card_num,
              card_bank: this.addFrom.card_bank,
            }
          }
          obj.config = JSON.stringify(obj.config);
          obj.extend = JSON.stringify(obj.extend);
          if(this.title == '新增')
          {
             api.VIPAdd(obj).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddVipok');
            } else {
              processErrors(res);
            }

          })
          }
          else
          {
             api.VIPAdded(obj).then(res => {
            if (res.code == 0) {
              this.$message({
                message: '创建成功',
                type: 'success'
              });
              this.$emit('AddVipok');
            } else {
              processErrors(res);
            }

          })
          }
         
        } else {
          return false;
        }
      });

    }
  },

  mounted() {
    if (this.editID) {
      let api = VIPmanagementAPI()
      api.detailsList(this.editID).then(res => {
        if (res.code == 0) {
          this.rules.password = []
          this.title = "编辑"
          if (res.data.config.zj_appid != null && res.data.config.zj_appid != '') {
            this.isUpdateDy = false
          }
          if (res.data.config.wx_appid != null && res.data.config.wx_appid != '') {
            this.isUpdateWx = false
          }
          this.addFrom = {
            username: res.data.username,
            nickname: res.data.nickname,
            password: res.data.password,
            email: res.data.email,
            mobile: res.data.mobile,
            status: res.data.status,
            id: res.data.id,
            group: res.data.group,
            zj_appid: res.data.config.zj_appid,
            wx_appid: res.data.config.wx_appid,
            launch_type: res.data.config.launch_type,
            chapter_switch:res.data.config.chapter_switch,
            pay_switch:res.data.config.pay_switch,
            company_abbr: res.data.config.company_abbr,
            zj_appname: res.data.config.zj_appname,
            wx_appname: res.data.config.wx_appname,
            company_name: res.data.config.company_name,
            benefit: res.data.extend.benefit,
            pay_method: res.data.extend.pay_method,
            card_holder: res.data.extend.card_holder,
            card_num: res.data.extend.card_num,
            card_bank: res.data.extend.card_bank,
            pay_type: res.data.config.pay_type,
          }
          this.EditFlag = true
          this.isInputDisabled = true
          this.radioFlag = true
          this.flagTab = true
        } else {
          processErrors(res);
        }
      })
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn{
  font-size: 30px;
  font-weight: bold;
}
</style>